export default class MathService {
    public static roundToSix(num: number) {
        return +(Math.round(Number(num + 'e+6')) + 'e-6');
    }
}
